'use-client';
import CustomElementComponent from '../../CustomElementComponent';

export default CustomElementComponent;
